// Hardcoded part categories for V1
// Service parts only (no spark plugs, batteries, wear parts, etc — those come later)

export const PART_CATEGORIES = [
  { code: 'engine_oil_filter',    label: 'Engine oil filter' },
  { code: 'air_filter',           label: 'Air filter' },
  { code: 'fuel_filter',          label: 'Fuel filter' },
  { code: 'hydraulic_oil_filter', label: 'Hydraulic oil filter' },
  { code: 'cabin_filter',         label: 'Cabin filter' },
  { code: 'engine_oil',           label: 'Engine oil' },
  { code: 'hydraulic_oil',        label: 'Hydraulic oil' },
  { code: 'coolant',              label: 'Coolant' },
  { code: 'grease',               label: 'Grease' },
  { code: 'belt',                 label: 'Belt' },
];

export const PART_UNITS = [
  { code: 'each',   label: 'each' },
  { code: 'litre',  label: 'litres' },
  { code: 'kg',     label: 'kg' },
];

export const getPartCategoryLabel = (code) =>
  PART_CATEGORIES.find(c => c.code === code)?.label || code;

export const getPartUnitLabel = (code) =>
  PART_UNITS.find(u => u.code === code)?.label || code;
